<template>
  <v-text-field
    ref="inputRef"
    v-model="formattedValue"
    v-bind="$attrs"
    @blur="$emit('blur', $event)"
    @click:append="$emit('click:append', $event)"
    @click:append-outer="$emit('click:append-outer', $event)"
    @click:clear="$emit('click:clear', $event)"
    @click:prepend="$emit('click:prepend', $event)"
    @click:prepend-inner="$emit('click:prepend-inner', $event)"
    @focus="$emit('focus', $event)"
    @keydown="$emit('keydown', $event)"
    @mousedown="$emit('mousedown', $event)"
    @mouseup="$emit('mouseup', $event)"
    @update:error="$emit('update:error', $event)"
  >
    <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
  </v-text-field>
</template>

<script>
import {watch, computed} from 'vue'
import {useCurrencyInput} from 'vue-currency-input'

export default {
  props: {
    currency: {
      type: String,
      default: 'BRL',
    },

    locale: {
      type: String,
      default: 'pt-BR',
    },

    value: {
      type: [String, Number],
      default: 0,
    },
  },

  setup(props) {
    const computedOptions = computed(() => {
      return {
        currency: props.currency,
        locale: props.locale,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        valueRange: {min: 0},
        autoDecimalDigits: true,
      }
    })

    const {formattedValue, setValue, inputRef, setOptions} = useCurrencyInput(
      computedOptions.value
    )

    watch(
      () => props.value,
      (newValue) => {
        setValue(newValue)
      }
    )

    watch(computedOptions, (newValue) => {
      setOptions(newValue)
    })

    return {
      inputRef,
      formattedValue,
    }
  },
}
</script>
